// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Jr-z","giftOrPromoSelector":"Kr-z","disabled":"Lr-z","subTitle":"Mr-z","selectShipAddressMessage":"Nr-z","changePayment":"Or-z"};